import axios from 'axios';

export function requestAvailableTimesSingleBooking(context, payload) {
	axios.post('/wp-json/fws/v1/available_times_single_booking', {action: 'wc_bookings_get_blocks', form: payload})
		.then((response) => {
			context.commit('SET_AVAILABLE_TIME_SINGLE_BOOKING', response.data.data);
		})
		.catch(e => {
			throw e;
		});
}
